import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventGroupArray'
})
export class EventGroupArrayPipe implements PipeTransform {
  /**
   *
   * @param items
   * @param keyArray
   * @param eventShubetsu
   */
  transform(items: any[], keyArray: any[], eventShubetsu: string): any {
    if (!items) {
      return [];
    }
    if (!keyArray.length) {
      return items;
    }
    let eventFilteredArray　= items;
    if (keyArray.length) {
      keyArray.forEach((key: string) => {
        // tempArrayにeventShubetsuと鶏舎が同じものを抽出
        const tempArray = items.filter((x: any) => {
          return x.taishouKeisha === key && x.eventShubetsu === eventShubetsu;
        });
        // eventFilterdArrayにイベントリストからtempArrayで抽出した以外のものを取り出す
        eventFilteredArray = eventFilteredArray.filter((y: any) => {
          return y.taishouKeisha !== key || y.eventShubetsu !== eventShubetsu;
        });
        // eventFilterdArrayにtempArrayを追加
        if (tempArray.length) {
          eventFilteredArray.unshift(tempArray);
        }
      });
    }
    return eventFilteredArray;
  }
}
